import { TableHeader } from '../../commons'
import { CLIENT_GROUP_HEADERS } from '../../../constant/tableHeadersConstants/masterDataContants/masterDataClientGroupListConst'
import ClientGroupTableData from './ClientGroupTableData';
import InfiniteLoader from '../../commons/InfiniteLoader/InfiniteLoader';
import ScrollToTop from '../../commons/ScrollToTop';

type AppProps = {
    isClientGroupEditButtonPresent: boolean;
    fetching: boolean;
    offset: number;
    data: any;
    handleEditMasterClientGroup: (data: any) => void;
}

const ClientGroupTable = ({
    fetching,
    offset,
    isClientGroupEditButtonPresent,
    data,
    handleEditMasterClientGroup
}: AppProps) => {

    return (
        <div className='jobsType'>
            <table className="table thead-light table-bordered">
                <thead className='text-start sticky-table-header'>
                    <TableHeader
                        tableHeader={CLIENT_GROUP_HEADERS}
                    />
                </thead>
                <tbody>
                    <ClientGroupTableData
                        data={data}
                        tableHeader={CLIENT_GROUP_HEADERS}
                        handleEditMasterClientGroup={handleEditMasterClientGroup}
                        isClientGroupEditButtonPresent={isClientGroupEditButtonPresent}
                    />
                    {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
                    <div style={{ display: fetching ? "none" : "inline" }}>
                        <ScrollToTop />
                    </div>
                </tbody>
            </table>
        </div>
    )
}

export default ClientGroupTable